<template>
  <div v-for="a in showDataList" :key="a.subId" class="nav-item">
    <div
      :style="{
        marginLeft: a.num * 15 + 'px',
        fontWeight: '400',
        fontSize: '14px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textAlign: 'start',
        position: 'relative',
        width: a.children
          ? `calc(100% - ${a.num * 15}px)`
          : 'calc(100% - 15px)',
        height: '100%',
        cursor: 'default',
        display: 'flex',
        alignItems: 'center',
        alignContent: 'center',
      }"
    >
      <a
        :href="`${'#' + a.subId}`"
        data-bs-toggle="collapse"
        role="button"
        aria-expanded="false"
        :aria-controls="a.subId"
        :data-key="a.name"
        class="text-dark"
        @click="changeType(a)"
      >
        <i style="margin-left: 20px"></i>
        <i :class="[
            'fs-12',
            a.has_children ? ( a.iconType ? ' bx bxs-down-arrow' : 'bx bxs-right-arrow' ) : ' bx bxs-down-arrow',
          ]"
          style="color: #212529; position: absolute; top: 3px; left: 5px"
        ></i>
      </a>
      <div
        style="
          display: inline-block;
          width: 90%;
          display: flex;
          alignitems: center;
          aligncontent: center;
        "
        :class="[`active-${a.id}`,(itemSelecteds === a.id) && 'item-active']"
        @click.stop="selectedsDetail(a)"
        :draggable="false"
        @dragstart="dragStart(a)"
      >
        <!-- <i
          :class="[
            'ri-checkbox-blank-circle-fill',
            status(a, { health: 0, 'sub-health': 0, error: 0, unknown: 0 }),
            'me-1',
          ]"
        ></i> -->
        <span>{{ a.root_sn ? a.root_sn : "-" }}</span>
      </div>
    </div>
    <div :class="[`collapse-${a.id}`,'collapse']" :id="a.subId">
      <template v-if="showMeasurement">
        <div
          :style="{
            marginLeft: (a.num * 15 + 15) + 'px',
            paddingLeft: '10px',
            cursor: 'default',
            display: 'flex',
            alignItems: 'center',
            alignContent: 'center',
          }"
          v-for="b in a.attributes.measurements"
          :class="{ 'item-active': itemSelecteds === `${a.id}&&${b.id}` }"
          :key="b.name"
          draggable="true"
          @dragstart="dragStart(a, b)"
          @click="selectedsDetail(b, a)"
        >
          <!-- <i
            style="display: inline-block"
            :class="[
              'ri-checkbox-blank-circle-fill',
              b.status || 'unknown',
              'me-1',
            ]"
          ></i> -->

          <img
            src="../assets/images/value.svg"
            style="width: 20px; height: 16px"
            alt=""
          />
          {{ b.name }}
        </div>
      </template>
      <equipTree
        :dataList="a.children"
        :itemSelecteds="itemSelected"
        @getDetailId="selectedsDetail"
        @getDragCharts="getDragCharts"
        :itemSelected="itemSelecteds"
        :showMeasurement="showMeasurement"
      ></equipTree>
    </div>
  </div>
  <!-- </Draggable> -->
  <!-- </Container> -->
</template>

<script>
import equipTree from "./equipTree";
// import { Container, Draggable } from "vue3-smooth-dnd";
import _ from "loadsh";
import { getInstancesDetail } from "@/service/index";
// import { getLatestTimeseries } from "@/service/index";
// import { changeState } from "@/utils/filter.js";
export default {
  emits: [
    "getDetailId",
    "getDragCharts",
  ],
  inject: ['getChildren'],
  components: {
    equipTree,
    // Container,
    // Draggable,
  },
  props: {
    dataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    itemSelected: {
      type: String,
      default: () => {
        return "";
      },
    },
    showMeasurement: {
      type: Boolean,
      default: false,
    },
    init: Number,
  },
  data() {
    return {
      itemSelecteds: "",
      showDataList: [],
      warnStatusList: ["health", "sub-health", "error", "unknown"],
      isSelect:null,
      inntAction:false, // 初始状态
      num:1,
    };
  },
  watch: {
    dataList: {
      handler: function (newval) {
        if (!newval.length) {
          this.showDataList = []
          return;
        }
        this.showDataList = newval[0].status
          ? newval
          : this.recursionStateArr(newval);

        /* 默认选中状态 */ 
        if(this.isSelect&&this.isSelect.has_parent){
          this.showDataList.forEach(item=>{
            if(this.isSelect && this.isSelect.parent_id == item.id){
              this.itemSelecteds = item.id //选中
              this.isSelect = null
              return;
            }
          })         
        }

      },
      deep: true,
      immediate: true,
    },
    itemSelected: {
      handler(newVal) {
        this.itemSelecteds = newVal;
      },
    },
    $route(to) {
      let deviceTreeActive = sessionStorage.getItem("deviceTreeActive") || "";
      if (
        to.path == "/equipment-management" &&
        deviceTreeActive.includes("&&")
      ) {
        this.itemSelecteds = deviceTreeActive.split("&&")[0];
        sessionStorage.setItem("deviceTreeActive", this.itemSelecteds);
      }
    },
  },
  methods: {
    _getChildren(data, parent_id) {
      this.getChildren(data, parent_id);
    },
    changeType(item) {
      if( this.num==1 && this.$route.path == "/iot/atlas-analysis"){ //针对图谱分析
        this.num += 1
        let active = sessionStorage.getItem("deviceChildTreeActive")
        sessionStorage.removeItem('deviceChildTreeActive')

        document.querySelector(`.collapse-${sessionStorage.getItem("deviceTreeActive")}`).classList.remove('show')
        if(document.querySelector(`.active-${active}`)){
          document.querySelector(`.active-${active}`).classList.remove('item-active')
        }

      }
      if (!item.has_children) {
        return;
      }
      item["iconType"] = !item["iconType"];
      let params = {
        is_tree_table: true,
        parent_id: item.id,
        page_size: 0,
      };
      this.isLoading = true
      getInstancesDetail(params)
        .then((res) => {
          if (res.payload.data) {
            let _data = _.cloneDeep(res.payload.data)
            _data.map((_item) => {
              _item.attributes.measurements = this.filterMeasurements(_item)
              _item.num = item.num + 1
              _item.subId = "a" + _item.id
            })
            item.children = _data
            // this._getChildren(_data, item.id);
          }

        })
        .catch((err) => {
          console.log(err);
        });
    },
    status(a, obj) {
      let status = "unknown";//给个默认状态

      _.get(a, ["attributes", "measurements"]).map((item) => {
        obj[item.status] += 1;
      });
      if (a.children && a.children.length) {
        a.children.forEach((child) => {
          this.status(child, obj);
        });
      }

        if(obj["health"] >=1){
          status = "health";
        }
        if (obj["sub-health"] >= 1){
          status = "sub-health";
        }
        if(obj["error"] >= 1){
          status = "error";
        }
      // if (obj["error"] >= 1) {
      //   return "error";
      // } else if (obj["sub-health"] >= 1) {
      //   return "sub-health";
      // } else if (obj["unknown"] >= 1) {
      //   return "unknown";
      // } else if (obj["health"] >= 1) {
      //   return "health";
      // } else {
      //   return "unknown";
      // }
      return status;
    },
    recursionStateArr(data) {
      data.forEach((child) => {
        _.get(child, ["attributes", "measurements"]).map((item) => {
          item.status = "unknown";
        });
        child.status = "unknown";
        if (child.children && child.children.length) {
          this.recursionStateArr(child.children);
        }
      });
      return data;
    },
    selectedsDetail(item, aItem) {
      localStorage.setItem("equipmentData", JSON.stringify(item));
      if (aItem) {
        var deviceId = aItem.id;
        localStorage.setItem("equipmentData", JSON.stringify(aItem));
      }
      this.itemSelecteds = deviceId ? `${deviceId}&&${item.id}` : item.id;
      sessionStorage.setItem("deviceTreeActive", this.itemSelecteds);
      if (deviceId) {
        //若点击是测点，存储测点信息
        sessionStorage.setItem("measureInfo", JSON.stringify(item));
      } else {
        sessionStorage.removeItem("measureInfo");
      }

      if (!item.children) {
        //点击测量值前往健康监控页面
        if (
          this.$route.path == "/equipment-management" ||
          this.$route.path == "/equipment-detail"
        ) {
          this.$router.push({
            name: "health-monitor",
            params: {
              deviceId: deviceId,
              measure_key: item.key,
              measure_name: item.name,
              measure_id: item.id,
            },
          });
          return;
        }
      }
      this.$emit("getDetailId", item, aItem);
    },

    dragStart(a, b) {
      localStorage.setItem("equipmentData", JSON.stringify(a));

      this.$emit("getDragCharts", {
        obj: b,
        data: a,
      });
    },
    caseOnDrop(dropResult) {
      const removedIndex = dropResult.removedIndex; // 原index
      const addedIndex = dropResult.addedIndex; // 移动后index
      if (removedIndex === addedIndex) {
        return false;
      }
      const arr = this.applyDrag(this.addCaseList, dropResult);
      this.addCaseList = arr;
    },
    getDragCharts({ obj, data }) {
      this.$emit("getDragCharts", {
        obj: obj,
        data: data,
      });
    },
    // getChildren(children, parent_id){
    //   this.$emit("getChildren", children, parent_id);
    // }
    /* 过滤掉不展示测点 */
    filterMeasurements(child){
      /* 测点列表,筛选出需要展示的测点数据 */
      let info = _.cloneDeep(child)
      let list = []
      if(info.attributes&&info.attributes.measurements.length){
        list= info.attributes.measurements.filter(item=>item.is_show === undefined || item.is_show )
      }
      return list;
    }
  },
  created() {},
  mounted() {
    this.itemSelecteds = sessionStorage.getItem("deviceTreeActive") || "";
    this.isSelect =  JSON.parse( localStorage.getItem("equipmentData") );
    this.showDataList.map((item) => {
      item["iconType"] = false;
      if (
        document.getElementById(item.subId) &&
        document.getElementById(item.subId).className.indexOf("show") > -1
      ) {
        item["iconType"] = true;
      }
      });

      /* 从健康监控跳转到图谱分析默认高亮设备序列号（如果有） */ 
      if(this.$route.path == "/iot/atlas-analysis"){
        this.$nextTick(()=>{
          let selectedId = sessionStorage.getItem("deviceTreeActive");
          let dom = document.querySelector(`.collapse-${selectedId}`)
          if(!selectedId||!dom){
            return;
          }

          if (dom) {
            dom.classList.add('show')
          }

          let childDom = sessionStorage.getItem("deviceChildTreeActive")
          if(childDom){
            document.querySelector(`.active-${childDom}`).classList.add('item-active')
            document.querySelector(`.active-${selectedId}`).classList.remove('item-active')
            // sessionStorage.removeItem('deviceChildTreeActive') //删除跳转过来的数据
          }
  
        })
      }
  },
};
</script>

<style lang="scss" scoped>
.item-active {
  background: rgb(229, 236, 250);
}
.a-item:hover {
  background: #f3f3f9;
  cursor: default;
}
</style>
